@layer module {
.selector-wrapper {
            display: flex;
            flex-flow: column nowrap;
    }

.selector-root {
            position: relative;
    }

.selector-control {
            cursor: pointer;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: space-between;
    }

.selector-control.static {
            cursor: default;
    }

.selector-selection {
            display: flex;
            align-items: center;
    }

.selector-selection-content,
.selector-option-content {
            display: flex;
            flex-flow: column nowrap;
    }

.selector-menu {
            display: none;
            position: absolute;
            z-index: 101;
            overflow-y: auto;
    }

.selector-menu.is-opened {
            display: block;
    }

.selector-option {
            cursor: pointer;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
    }
} // layer module










@layer app {
.selector-wrapper {
            width: 100%;
    }

.selector-root {
            width: 100%;
    }

.selector-control {
            width: 100%;
            border-radius: $size-10;
    }

.selector-selection-icon,
.selector-option-icon {
            width: $size-26;
            height: $size-26;
            margin-right: $size-10;
    }

.selector-menu {
            top: $size-50;
            left: 0;
            right: 0;
            max-height: $size-250;
            border-radius: $size-11;
            padding: $size-10 0;
    }

.selector-option {
            width: 100%;
            height: $size-40;
            padding: 0 $size-10;
    }

.selector-error {
            margin-top: $size-5;
    }

.selector-control {
            background: var(--banky-white);
            color: var(--custom-selector-control-text);
            font-size: var(--font-size-xs);
            font-style: normal;
            font-weight: 400;
            line-height: $size-12;
    }

.selector-control.error {
            border-color: var(--custom-selector-error);
    }

.selector-placeholder {
            padding-left: calc(var(--input-placeholder-inline-inset) - $size-10);
            font-size: var(--font-size-base);
            font-weight: 400;
            line-height: $size-17;
    }

.selector-menu {
            background-color: var(--banky-white);
            box-shadow: var(--shadow-selector-menu);
            color: var(--custom-selector-menu-text);
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 400;
            line-height: 120%;
    }

.selector-menu :global(.currency-name) {
            color: var(--banky-black);
    }

.selector-error {
            color: var(--custom-selector-error);
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 400;
            line-height: $size-18;
    }
} // layer app










@layer context {
:global(.filter-pill) .selector-control {
            width: auto;
            background: transparent;
            border: none;
            box-shadow: none;
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

:global(.filter-pill) .selector-selection-icon {
            display: none;
    }

:global(.filter-pill) .selector-placeholder {
            padding-left: 0;
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

:global(.filter-pill) .selector-menu {
            top: calc(100% + $size-10);
            right: auto;
            left: $size-neg-12;
            min-width: $size-280;
    }
} // layer context
